import { getFunction } from "../../../Common";
import { ExecuteSend, CanQueryData, GenerateExecuteRequest, RESTResponseFormatter } from "../../Helpers";
// Note: When testing RESTClient or, component that uses RESTClient
// window.navigator.onLine needs to be mocked
export class RESTClient {
    constructor(options) {
        this.retryInterval = options.retryInterval || 1000;
        this.maxRetryAttempts = options.maxRetryAttempts || 5;
        this.handlers = {
            requestFormatter: getFunction(options.handlers.requestFormatter),
            responseFormatter: getFunction(options.handlers.responseFormatter, RESTResponseFormatter)
        };
        this.cachedMessages = {};
        this.clearCachedMessage = this.clearCachedMessage.bind(this);
    }
    connect() {
        return Promise.resolve(CanQueryData());
    }
    deactivate() {
        return Promise.resolve(true);
    }
    isConnected() {
        return Promise.resolve(CanQueryData());
    }
    isConnectedSync() {
        return CanQueryData();
    }
    send(message) {
        const stringifiedMessage = JSON.stringify(message);
        if (typeof this.cachedMessages[stringifiedMessage] === "undefined") {
            this.cachedMessages[stringifiedMessage] = new Promise((resolve, reject) => {
                ExecuteSend({
                    request: GenerateExecuteRequest(message, this.handlers.requestFormatter, this.handlers.responseFormatter),
                    resolve: (x) => {
                        this.clearCachedMessage(stringifiedMessage);
                        resolve(x);
                    },
                    reject: (x) => {
                        this.clearCachedMessage(stringifiedMessage);
                        reject(x);
                    },
                    retryAttempt: 0,
                    retryInterval: this.retryInterval,
                    maxRetryAttempts: this.maxRetryAttempts
                });
            });
        }
        return this.cachedMessages[stringifiedMessage];
    }
    clearCachedMessage(message) {
        delete this.cachedMessages[message];
    }
    updateToken(token) { }
}
//# sourceMappingURL=RESTClient.js.map